import { css } from 'styled-components';

export const colors = new Proxy({}, {
  get: (_, name) => {
    return css`${({ theme }) => theme.colors[name]}`;
  }
});

